/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Biaya_TInputs */

const en_mk_tut_biaya_t = /** @type {(inputs: Mk_Tut_Biaya_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost, quota and plans`)
};

const id_mk_tut_biaya_t = /** @type {(inputs: Mk_Tut_Biaya_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya, kuota, dan paket`)
};

/**
* | output |
* | --- |
* | "Cost, quota and plans" |
*
* @param {Mk_Tut_Biaya_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_biaya_t = /** @type {((inputs?: Mk_Tut_Biaya_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Biaya_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_biaya_t(inputs)
	return en_mk_tut_biaya_t(inputs)
});